import { Box, Button } from '@mui/material';
import { type SMBSearchResultWithURL } from '@/types/SearchDirectory';
import { LatestReview } from '@/components/feature/searchDirectory/LatestReview';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import { ScreenName } from '@/constants';
import { SMBOverview } from './SMBOverview';
import { SMBExperienceSummary } from './SMBExperienceSummary';
import { SMBAttributesTagList } from './SMBAttributesTagList';
import { hasPhilosophiesOrSchoolTypes } from './helpers/hasPhilosphiesOrSchoolTypes';

export interface SMBCardFullProps {
  searchResult: SMBSearchResultWithURL;
}

export const SMBCardFull = ({ searchResult }: SMBCardFullProps) => {
  const {
    seoSegmentationProvider: {
      provider: { description, id },
    },
    philosophies,
    schoolTypes,
  } = searchResult;

  const fireAnalyticsEvent = () => {
    trackAmplitudeEvent(AmplitudeEvent.ctaInteracted, {
      screen_name: ScreenName.SEGMENTATION,
      cta_text: 'See info',
      provider_id: id,
    });
  };

  return (
    <Box
      width="100%"
      px={3}
      py={4}
      borderRadius={6}
      sx={{ mt: 4, '&:first-of-type': { mt: 0 } }}
      bgcolor="background.primary">
      <SMBOverview searchResult={searchResult} />
      <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }}>
        <Box>
          {hasPhilosophiesOrSchoolTypes(philosophies, schoolTypes) && (
            <Box mt={3}>
              <SMBAttributesTagList philosphies={philosophies} schoolTypes={schoolTypes} />
            </Box>
          )}
          {description && (
            <Box mt={3}>
              <SMBExperienceSummary experienceSummary={description} providerID={id} />
            </Box>
          )}
          {searchResult.latestReview && (
            <Box mt={3}>
              <LatestReview latestReview={searchResult.latestReview} />
            </Box>
          )}
        </Box>
        <Button
          href={searchResult.profileURL}
          target="_blank"
          size="medium"
          sx={{ minWidth: '160px', ml: 4, alignSelf: 'flex-end' }}
          color="primary"
          onClick={fireAnalyticsEvent}
          variant="contained">
          {`See info`}{' '}
        </Button>
      </Box>
    </Box>
  );
};

export default SMBCardFull;
